import React, {
  useState,
  useEffect,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import axios from "axios";
import { useTranslation } from "react-i18next";
import SelectSingle from "react-select";

import customStyles from "../../../../assets/select/customStyles";

const AreaSettingsTypes = forwardRef((props, ref) => {
  const { t } = useTranslation();

  const { data, type: settingsType } = props;

  const jwt = localStorage.getItem("JWT");
  const link = localStorage.getItem("link");
  axios.defaults.headers.common["Authorization"] = "Bearer " + jwt;

  const [selected, setSelected] = useState(null);
  const [originalId, setOriginalId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [types, setTypes] = useState([]);

  useEffect(() => {
    const stored = JSON.parse(localStorage.getItem("lotTypes") || "[]");
    setTypes(stored);
  }, []);
  const options = useMemo(
    () =>
      types.map((t) => ({
        value: t.id,
        label: <div className="flex-iac settings-item">{t.name}</div>,
      })),
    [types],
  );

  const isDirty = () => {
    const currentId = selected?.value ?? null;
    return currentId !== originalId;
  };

  const reset = () => {
    if (originalId === null) {
      setSelected(null);
    } else {
      const originalOption =
        options.find((o) => o.value === originalId) || null;
      setSelected(originalOption);
    }
  };

  const save = async () => {
    if (!isDirty() || saving || !selected) return;

    setSaving(true);

    try {
      await axios.put(
        link + "/api/" + settingsType + "/Type?typeId=" + selected.value,
        data.ids,
        {},
      );

      setOriginalId(selected.value);
    } finally {
      setSaving(false);
    }
  };

  useImperativeHandle(ref, () => ({
    isDirty,
    save,
    reset,
  }));

  useEffect(() => {
    const typeId = data?.countingAreaLotTypeId;

    if (typeId === undefined || typeId === null) {
      setSelected(null);
      setOriginalId(null);
      return;
    }

    const found = options.find((o) => o.value === typeId) || null;

    setSelected(found);
    setOriginalId(typeId);
  }, [data, options]);

  function render() {
    return (
      <SelectSingle
        className="select"
        styles={customStyles}
        isSearchable={false}
        value={selected}
        onChange={setSelected}
        options={options}
        theme={(theme) => ({
          ...theme,
          borderRadius: 3,
          colors: { ...theme.colors, primary: "#20a0ff" },
        })}
      />
    );
  }

  return <div>{render()}</div>;
});

export default AreaSettingsTypes;
